/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

import $ from 'jquery';

/**
 *  Show/Hide recover password form
 */
function toggleRecoverPasswordForm() {
  $('#RecoverPasswordForm').toggleClass('hide');
  $('#CustomerLoginForm').toggleClass('hide');
}

function onShowHidePasswordForm(evt) {
  evt.preventDefault();
  toggleRecoverPasswordForm();
}

function checkUrlHash() {
  const {hash} = window.location;

  // Allow deep linking to recover password form
  if (hash === '#recover') {
    toggleRecoverPasswordForm();
  }
}

/**
 *  Show reset password success message
 */
function resetPasswordSuccess() {
  const $formState = $('.reset-password-success');

  // check if reset password form was successfully submited.
  if (!$formState.length) {
    return;
  }

  // show success message
  $('#ResetSuccess').removeClass('hide');
  $('#CustomerLoginForm').toggleClass('hide');

  // Resize Register CTA on Password reset success
  const registerSuccessHeight = $('#ResetSuccess').outerHeight();
  console.log(registerSuccessHeight);
  $('.login__registerCTA').outerHeight(registerSuccessHeight);
}

if (document.body.classList.contains('template-login')) {
  const selectors = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '.HideRecoverPasswordLink',
  };

  if ($(selectors.recoverPasswordForm).length) {
    checkUrlHash();
    resetPasswordSuccess();

    $(selectors.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(selectors.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);
  }

  $(document).on('submit', 'form#create_customer', (e) => {
    console.log('Register Form Password Validation 🕵🏻‍♂️');
    if ($('input#CreatPassword').val() !== $('input#ConfirmPassword]').val()) {
      e.preventDefault();
      alert('Passwords do not match.');
    }
  });

  $(() => {
    $('#ResendEmail').click(() => {
      console.log('Resend Email!');
      $('#ResetSuccess').addClass('hide');
      $('#RecoverPasswordForm').removeClass('hide');
    });
  });
}
